import { PTS } from '../types';
import { usePatients } from '../hooks/usePatients';
import { useProfessionals } from '../hooks/useProfessionals';
import { X, Target } from 'lucide-react';

interface PTSDetailsProps {
  pts: PTS;
  onClose: () => void;
}

export default function PTSDetails({ pts, onClose }: PTSDetailsProps) {
  const { patients } = usePatients();
  const { professionals } = useProfessionals();
  
  const patient = patients.find(p => p.id === pts.patientId);
  const coordinator = professionals.find(p => p.id === pts.coordinatorId);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Detalhes do PTS</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        <div className="p-6 space-y-6">
          <div className="bg-medical-50 rounded-lg p-4">
            <h3 className="text-lg font-bold text-gray-900">{patient?.name || 'Paciente não encontrado'}</h3>
            <p className="text-gray-600">Coordenador: {coordinator?.name || 'Não encontrado'}</p>
          </div>

          <div>
            <h4 className="text-lg font-medium text-gray-900 mb-4 flex items-center">
              <Target className="h-5 w-5 mr-2" />
              Objetivos Terapêuticos
            </h4>
            <div className="space-y-2">
              {pts.objectives.map((objective, index) => (
                <div key={index} className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                  <p className="text-sm text-gray-900">{objective}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}